export const timeZones = [{ label: 'Europe/Madrid', value: 'Europe/Madrid' }];
